module.exports = __webpack_public_path__ + "img/bg_xsfx_xse@2x.1589e43c.png";